module.exports = __webpack_public_path__ + "static/img/FC100watergun.1655581.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/FC100watergun.png
// module id = PgZr
// module chunks = 1